import { useMutation, useQueryClient } from '@tanstack/react-query';
import { moveFolder } from '../api/filesApi';
import { folderContentsKeys } from './useFolderContents';

export function useMoveFolder(siteId: number) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      folderId,
      targetParentFolderId,
    }: {
      folderId: string;
      targetParentFolderId: string | null;
    }) => moveFolder(siteId, folderId, targetParentFolderId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: folderContentsKeys.all,
      });
    },
  });
}
